
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { environment } from 'src/environments/environment';
import { LeftSidebarService } from 'src/services/left-sidebar.service';
import { EvMultiSearchComponent } from "../ev-multi-search/ev-multi-search.component";
import { SearchGuideComponent } from "../ev-multi-search/search-guide/search-guide.component";
import { SearchMode } from 'src/services/search-state.service';

@Component({
    selector: 'searchbar',
    imports: [EvMultiSearchComponent, NgClass, SearchGuideComponent],
    templateUrl: './search-bar.component.html',
    styleUrl: './search-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent {
    leftSidebarService = inject(LeftSidebarService);
    expand = false;
    SearchModeEnum = SearchMode;
    searchMode: SearchMode = SearchMode.MULTISEARCH;

    goToSearch() {
        window.open(`${environment.evwebUrl}/frontpage`, '_blank');
    }

    openSearch() {
        this.expand = true;
    }

    searchChange(event: any) {
        this.searchMode = event;
    }
}
